import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bpjs',
  templateUrl: './bpjs.component.html',
  styleUrls: ['./bpjs.component.css']
})
export class BpjsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
